import type { Entry } from 'contentful'

// TODO check if possible to use useLocalPath in SSG mode
export function useEntryLink(entry: Entry) {
  switch (entry.sys.contentType.sys.id) {
    case 'parentHome':
    case 'homepage':
      return `/`
    case 'product':
      if (entry.fields.product_hub) {
        const productHub = entry.fields.product_hub as Entry

        return `/${productHub.fields.slug}/${entry.fields.slug}`
      }

      throw new Error(`Missing entry link mapper for "${entry.sys.contentType.sys.id}"`)
    case 'product_hub':
      return `/${entry.fields.slug}`
    case 'article':
      return `/conseils/${entry.fields.slug}`
    case 'advice':
      return `/conseils`
    case 'contact':
      return `/contact`
    case 'faq':
      return `/faq`
    case 'question':
      return `/faq/${entry.fields.slug}`
    case 'sub_product':
      if (entry.fields.product && (entry.fields.product as Entry).fields.product_hub) {
        const product = entry.fields.product as Entry
        const productHub = product.fields.product_hub as Entry

        return `/${productHub.fields.slug}/${product.fields.slug}/${entry.fields.slug}`
      }

      throw new Error(`Missing entry link mapper for "${entry.sys.contentType.sys.id}"`)
    case 'page':
      return `/infos/${entry.fields.slug}`
    case 'simulator':
      return `/simulateur`
    case 'teasing_page':
      return `/annonce/${entry.fields.slug}`
    case 'insurance_page':
      return `/assurance/${entry.fields.slug}`
    case 'myself_page':
      return `/myself`
    case 'link':
      return `/`
    case 'pageDatterrissage':
      return `/landing/${entry.fields.slug}`
    default:
      throw new Error(`Missing entry link mapper for "${entry.sys.contentType.sys.id}"`)
  }
}
